import { Router } from '@angular/router';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GlobalServices } from 'app/services/global.service';

@Component({
    selector: 'gis-credits-chooser',
    templateUrl: './gis-credits-chooser.component.html',
    styleUrls: ['./gis-credits-chooser.component.scss']
})
export class GISCreditsChooserComponent implements OnInit {
    @Output() emitOpenGisCredits: EventEmitter<any> = new EventEmitter();
   
	IsBusy: boolean = false;

	// Constructor
    constructor( private api: ssApiService, private router: Router, public gb: GlobalServices ) { }


    ngOnInit() {
    }
}
